import { useState, useEffect } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import { useNotification } from "../../contexts/NotificationContext";
import { authFetch } from '../../utils/authFetch';

const EditarAviso = () => {
    const { id } = useParams();
    const { showNotification } = useNotification();
    const navigate = useNavigate();

    const [description, setDescription] = useState('');
    const [notificationLevel, setNotificationLevel] = useState(0);

    useEffect(() => {
        const fetchAviso = async () => {
            try {
                const response = await authFetch('notification', {
                    method: 'PUT'                    
                });

                if (!response.ok) throw new Error('Erro ao buscar aviso');

                const data = await response.json();
                setDescription(data.description);
                setNotificationLevel(data.notificationLevel);
            } catch (error) {
                console.error(error);
                showNotification("danger", "Erro ao buscar aviso");
            }
        };

        fetchAviso();
    }, [showNotification]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        const payload = {
            id: id,
            description: description,
            notificationLevel: notificationLevel
        }

        try {
            const response = await authFetch('notification', {
                method: 'PUT',                
                body: JSON.stringify(payload),
            });

            if (!response.ok) throw new Error('Erro ao atualizar aviso');

            showNotification("success", "Aviso atualizado com sucesso!");
            navigate('/Avisos');
        } catch (error) {
            console.error(error);
            showNotification("danger", "Erro ao atualizar aviso");
        }
    };

    return (
        <div className="card">
            <div className="card-body p-3">
                <div className="row">
                    <aside className="column">
                        <div className="side-nav">
                            <h4 className="font-weight-bolder mb-0">Editar Aviso</h4>
                        </div>
                    </aside>
                    <div className="column-responsive column-80">
                        <div className="usuarios form content">
                            <form onSubmit={handleSubmit}>
                                <fieldset className="col-md-6">
                                    <div className="mb-3">
                                        <label>Descrição</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={description}
                                            onChange={(e) => setDescription(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label>Nível</label>
                                        <select
                                            className="form-control"
                                            value={notificationLevel}
                                            onChange={(e) => setNotificationLevel(parseInt(e.target.value))}
                                        >
                                            <option value={0}>Normal</option>
                                            <option value={1}>Importante</option>
                                        </select>
                                    </div>
                                    <div className="card-footer" style={{ paddingLeft: "0" }}>
                                        <Link to={'/Avisos'} className="btn btn-info btn-sm" >Voltar</Link>
                                        <button type="submit" className="btn btn-primary btn-sm mx-1">Salvar</button>
                                    </div>
                                </fieldset>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditarAviso;
